<template>
  <div class="footer-layout" :style="{marginLeft:(split-240)+'px'}">
    <ul class="footer-l">
      <li v-for="(item,i) in langKefu.arr" :key="i">
        {{item.key}} ： {{item.val}}
      </li>
    </ul>
    <div class="footer-r">
      <img :src="`${$cdn}images/service_img_ecode@2x.png`" alt="">
      <div>{{langKefu.wechat}}</div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  computed: {
    ...mapState({
      split: state => state.ui.navDivision,
      langKefu: state => state.language.home.kefu
    })
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
  .footer-layout{
    position: relative;
    max-width: 1180px;
    margin: 50px auto 72px;
    overflow: hidden;
    padding: 50px 50px 50px 65px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: #dcdcdc 1px solid;
    .footer-l{
      li{
        font-size: 12px;
        line-height: 26px;
        color: #888787;
        span{
          text-align: center;
          width: 46px;
          display: inline-block;
        }
      }
    }
    .footer-r{
      text-align: center;
      img{
        width: 145px;
      }
      div{
        font-size: 12px;
        line-height: 26px;
      }
    }
  }

  @media screen and (max-width: 1600px) {
    .footer-layout{
      margin: 50px auto 72px!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/service/footer.vue